import React from "react";
import {
  Box,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const FactoryItemSumReportData = this.props.FactoryItemSumReportData;
    const SelectedSearchValues = this.props.SelectedSearchValues;


    return (
      <div>
        <h3><center><u>Factory Item Summary Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{SelectedSearchValues.groupName} - {SelectedSearchValues.factoryName}</center></h4>
        <h4><center>Route: {SelectedSearchValues.routeName === undefined ? 'All Routes' : SelectedSearchValues.routeName}</center></h4>
        <h4><center>Item Category: {SelectedSearchValues.itemCategory === undefined ? 'All Item Categories' : SelectedSearchValues.itemCategory}</center></h4>
        <h4><center>Factory Item: {SelectedSearchValues.factoryItem === undefined ? 'All Factory Items' : SelectedSearchValues.factoryItem}</center></h4>
        <h4><center>{SelectedSearchValues.startDate} - {SelectedSearchValues.endDate}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer>
              <Table aria-label="caption table" style={{border:'1px solid #ccc', width: '99%', margin:'auto'}}>
                <TableHead>
                  <TableRow>
                    <TableCell align={'left'}>Route Name</TableCell>
                    <TableCell align={'left'}>Item Category</TableCell>
                    <TableCell align={'left'}>Factory Item</TableCell>
                    <TableCell align={'right'}>Quantity</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {FactoryItemSumReportData.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", padding: "7px 8px" }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", padding: "7px 8px" }}>
                        {data.categoryName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none", padding: "7px 8px" }}>
                        {data.itemName}
                      </TableCell>
                      <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none", padding: "7px 8px"  }}>
                        {data.quantity}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
      </div>
    );
  }
}
